<template>
  <!-- MODAL -->
  <div class="modal fade" id="exampleModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Edit User</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-2 col-form-label"
                >Nama Lengkap</label
              >
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  required
                  id="editNamePic"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-2 col-form-label"
                >Email</label
              >
              <div class="col-sm-10">
                <input
                  type="email"
                  class="form-control"
                  required
                  id="editEmailPic"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword" class="col-sm-2 col-form-label"
                >Phone</label
              >
              <div class="col-sm-10">
                <input
                  type="number"
                  class="form-control"
                  required
                  id="editPhonePic"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="inputPassword" class="col-sm-2 col-form-label"
                >Jabatan</label
              >
              <div class="col-sm-10">
                <select
                  name=""
                  required
                  class="form-control"
                  id="editJabatanPic"
                >
                  <option value="Admin Toko">Admin Toko</option>
                  <option value="Finance">Finance</option>
                  <option value="Manager">Manager</option>
                  <option value="Direktur">Direktur</option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Close
          </button>
          <button type="button" class="btn btn-primary">Save changes</button>
        </div>
      </div>
    </div>
  </div>
  <!-- END MODAL -->
</template>

<script>
export default {
  props: {
    listUser: Array,
  },
};
</script>